/**
 * @generated SignedSource<<991ce2d939a58c458f86c450ce401fbc>>
 * @relayHash cfd6fa9dcb9e9305611fc3619dc85ec3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6

import type { ConcreteRequest } from 'relay-runtime';
export type useAccessRequestSettingsQuery$variables = {
  cloudId: string;
};
export type useAccessRequestSettingsQuery$data = {
  readonly confluence_accessRequestSettings: {
    readonly contentAccessRequestSettings: {
      readonly enabled: boolean | null;
      readonly messageContent: string | null;
    } | null;
    readonly spaceAccessRequestSettings: {
      readonly enabled: boolean | null;
      readonly messageContent: string | null;
    } | null;
  } | null;
};
export type useAccessRequestSettingsQuery = {
  response: useAccessRequestSettingsQuery$data;
  variables: useAccessRequestSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "enabled"
  },
  {
    "kind": "ScalarField",
    "name": "messageContent"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceAccessRequestSettingsConfiguration",
    "kind": "LinkedField",
    "name": "confluence_accessRequestSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceAccessRequestSettings",
        "kind": "LinkedField",
        "name": "contentAccessRequestSettings",
        "plural": false,
        "selections": (v1/*: any*/)
      },
      {
        "concreteType": "ConfluenceAccessRequestSettings",
        "kind": "LinkedField",
        "name": "spaceAccessRequestSettings",
        "plural": false,
        "selections": (v1/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessRequestSettingsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessRequestSettingsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "cfd6fa9dcb9e9305611fc3619dc85ec3",
    "id": "5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6",
    "metadata": {},
    "name": "useAccessRequestSettingsQuery",
    "operationKind": "query",
    "text": "query useAccessRequestSettingsQuery($cloudId:ID!){confluence_accessRequestSettings(cloudId:$cloudId){contentAccessRequestSettings{enabled,messageContent},spaceAccessRequestSettings{enabled,messageContent}}}"
  }
};
})();

(node as any).hash = "a036ba125a56fbf2de00fed43babc58f";

export default node;
